import { isEmpty } from 'lodash'

export const onlyNumbers = (value) => {
  if (isEmpty(value)) return ''
  return value.replace(/\D/g, '')
}

export default onlyNumbers
